var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control ds-virtual-tree",
      attrs: { "drag-start": _vm.dragstart },
    },
    [
      _c(
        "DsfVirtualScroll",
        {
          attrs: { scrollX: true, scrollY: true },
          on: { scroll: _vm.onScroll },
        },
        [
          _vm.isInit && _vm.totalData
            ? _c(
                "div",
                {
                  staticClass: "ds-virtual-tree__warp",
                  style: "height: " + _vm.maxHeight + "px;",
                },
                [
                  _vm._l(_vm.showNodes, function (node) {
                    return _c(
                      "div",
                      {
                        key: node.id,
                        staticClass: "ds-virtual-tree-node",
                        class: _vm.customNodeClass(node),
                        style: node.style,
                        attrs: {
                          expanded: node.expanded,
                          "is-leaf": node.isLeaf,
                          "is-current": _vm.highlightCurrent && node.isCurrent,
                          "node-id": node.id,
                          draggable: _vm.draggable,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clickNode(node, $event)
                          },
                          dblclick: function ($event) {
                            $event.stopPropagation()
                            return _vm.dblclickNode(node, $event)
                          },
                          dragstart: function ($event) {
                            return _vm.dragStart($event, node)
                          },
                          dragend: function ($event) {
                            return _vm.dragEnd($event, node)
                          },
                          dragover: function ($event) {
                            return _vm.dragOver($event, node)
                          },
                          drop: function ($event) {
                            return _vm.drop($event, node)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ds-virtual-tree-node__content" },
                          [
                            _c("span", {
                              staticClass:
                                "ds-virtual-tree-node-expanded el-icon-caret-right",
                              attrs: {
                                "is-opacity": _vm.isExpandedOpacity(node),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.expandNode(node, !node.expanded)
                                },
                              },
                            }),
                            _c("el-checkbox", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowCheckbox(node),
                                  expression: "isShowCheckbox(node)",
                                },
                              ],
                              staticClass: "ds-virtual-tree-node-checkbox",
                              attrs: {
                                value: node.checked,
                                disabled: _vm.isDisabledNode(node),
                                indeterminate: node.indeterminate,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.checkboxClick(node, $event)
                                },
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return function () {}.apply(null, arguments)
                                },
                              },
                            }),
                            !node.loaded && node.loading
                              ? _c("span", {
                                  staticClass:
                                    "ds-virtual-tree-node-loading el-icon-loading",
                                })
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ds-virtual-tree-node__content_label",
                              },
                              [
                                _vm._t(
                                  "default",
                                  function () {
                                    return [
                                      _vm._v(" " + _vm._s(node.label) + " "),
                                    ]
                                  },
                                  { data: node.data, node: node }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm.filterText && !_vm.showNodes.length
                    ? _c("div", { staticClass: "ds-virtual-tree-empty-text" }, [
                        _vm._v(" " + _vm._s(_vm.emptyText) + " "),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm.isInit
            ? _c("div", { staticClass: "ds-virtual-tree-empty-text" }, [
                _vm._v(" " + _vm._s(_vm.emptyText) + " "),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }